
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useParams } from "react-router";

import { Box, Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Tab, Tabs, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

import ScannerIcon from '@mui/icons-material/Scanner';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import { MdDelete } from "react-icons/md";
import { CgPlayListRemove } from "react-icons/cg";

import Dynamsoft from "dwt";
import { WebTwain } from "dwt/dist/types/WebTwain";

import { TabPanel, TabProps } from "../../../helpers/TabPanel";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout"
import { InfoField } from "../../../components/InfoField";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxInformacionAmparo } from "../../../components/BoxInformacionAmparo";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionIrregular } from "../../../components/BoxInformacionIrregular";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";

import { DetalleNotificacion } from "../../../connections/notificaciones/NotificacionConnection";

import { defaultNotificacion, NotificacionProps } from "../../../interfaces/notificaciones/NotificacionesInterface";

export const SubirRazonamientoPage = () => {

    const { Id } = useParams();

    const dispatch = useDispatch();

    const containerId = 'dwtcontrolContainer';
    const width = "100%";
    const height = "500";

    const hoy = new Date();
    const fechaHoy = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;

    const [DWObject, setDWObject] = useState<WebTwain>();
    const [scanners, setScanners] = useState<string[]>( [] );
    const [currentScanner, setCurrentScanner] = useState( "0" );

    const [value, setValue] = useState( 0 );
    const [subTab, setSubTab] = useState( 'digitalizar' );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => { setValue( newValue ); }

    const handleChangeSubTab = ( _: React.MouseEvent<HTMLElement>, newValue: string | null ) => { if ( newValue !== null ) { setSubTab( newValue ); } }

    const [countPages, setCountPages] = useState( 0 );
    const [openConfirmacion, setOpenConfirmacion] = useState( false );
    const [openConfirmacionAll, setOpenConfirmacionAll] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [loading, setLoading] = useState( true );
    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const [notificacion, setNotificacion] = useState<NotificacionProps>( defaultNotificacion );

    const [seNotifico, setSeNotifico] = useState( true );
    const [fechaNotificacion, setFechaNotificacion] = useState( '' );
    const [motivoNoNotificacion, setMotivoNoNotificacion] = useState( '' );
    const [reagendarNotificacion, setReagendarNotificacion] = useState( false );
    const [fechaReagenda, setFechaReagenda] = useState( '' );

    const handleChangeFechaNotificacion = ( value: boolean ) => {

        setSeNotifico( value );
        setFechaNotificacion( '' );
        setMotivoNoNotificacion( '' );

    }

    const handleChangeFechaReagenda = ( value: boolean ) => {

        setReagendarNotificacion( value );
        setFechaReagenda( '' );

    }

    const validateFields = () => {

        let valid = true;

        if ( !seNotifico && motivoNoNotificacion === '' ) {
            valid = false;
            dispatch( openSnackbar({ message: 'Escribe el motivo de no realizar la notificación', variant: 'warning' }));
        }

        if ( seNotifico && fechaNotificacion === '' ) {
            valid = false;
            dispatch( openSnackbar({ message: 'Selecciona la fecha de notificación', variant: 'warning' }));
        }

        if ( reagendarNotificacion && fechaReagenda === '' ) {
            valid = false;
            dispatch( openSnackbar({ message: 'Selecciona la fecha para reagendar la notificación', variant: 'warning' }));
        }

        return valid;

    }

    const onSourceChange = ( value: string ) => {

        setCurrentScanner( value );

    }

    const acquireImage = async () => {

        if ( DWObject ) {

            DWObject.CloseSource();

            for (let i = 0; i < DWObject.SourceCount; i++) {
                if ( DWObject.GetSourceNameItems(i) === currentScanner ) {
                    DWObject.SelectSourceByIndex(i);
                    break;
                }
            }

            DWObject.IfDuplexEnabled = false;
            DWObject.IfFeederEnabled = true;
            DWObject.IfShowUI = true;
            DWObject.PixelType = Dynamsoft.DWT.EnumDWT_PixelType.TWPT_BW;
            DWObject.Resolution = 300;

            DWObject.OpenSource();

            DWObject.AcquireImage( () => { setCountPages( DWObject.HowManyImagesInBuffer ); });

        }

    }

    //-------------------------------------------------------------------------------------------------

    const GuardarDigitalizacion = () => {

        setLoadingFinalizar( true );

        if ( DWObject ) {

            if ( DWObject.HowManyImagesInBuffer > 0 ) {

                const strHTTPServer = window.location.hostname;
                const strActionPage = `Api/Notificacion/GuardarRazonamiento/`;

                if ( window.location.protocol === 'http:' ) {
                    DWObject.IfSSL = true;
                    DWObject.HTTPPort = 5006;
                }
                else if ( window.location.protocol === 'https:' ) {
                    DWObject.IfSSL = true;
                }

                const data = JSON.parse(window.localStorage.getItem('data') ?? '');

                if ( data ) {
                    const { token } = data;

                    DWObject.SetHTTPHeader('Authorization', 'Bearer ' + token);
                    DWObject.SetHTTPHeader('Access-Control-Allow-Origin', '*');

                    const campos: [string, string][] = [
                        ['id', Id ?? ""],
                        ['seNotifico', seNotifico ? "true" : "false"],
                        ['reagendarNotificacion', reagendarNotificacion ? "true" : "false"],
                        ['motivoNoNotificacion', motivoNoNotificacion.replace(/[\r\n]+/g, ' ')],
                        ['fechaNotificacion', fechaNotificacion],
                        ['fechaReagendarNotificacion', fechaReagenda],
                    ];

                    campos.forEach( ( [ nombre, valor ] ) => {

                        const agregado = DWObject.SetHTTPFormField( nombre, valor );

                        if ( !agregado ) {
                            console.warn( `No se pudo agregar el campo "${ nombre }" a la petición de GuardarRazonamiento` );
                        }

                    });

                }

                DWObject.HTTPUploadAllThroughPostAsPDF(strHTTPServer, strActionPage, "documento.pdf", OnHttpUploadSuccess, OnHttpUploadFailure);
                
                setOpenDialogConfirmacionFinalizar( false );
                setLoadingFinalizar( false );

            }
            else {

                dispatch(openSnackbar({ message: 'Debe escanear o subir el documento', variant: 'warning' }));
                setLoadingFinalizar( false );

            }

        }

    }

    //-------------------------------------------------------------------------------------------------

    const OnHttpUploadSuccess = () => handleTerminar()

    const OnHttpUploadFailure = ( errorCode: number, _: string, sHttpResponse: string ) => {

        dispatch( openSnackbar({ message: `Code: ${ errorCode }, ${ sHttpResponse }`, variant: 'error' }));

    }

    const loadImagesOrPDFs = () => {

        if ( DWObject ) {

            DWObject.IfShowFileDialog = true;
            DWObject.Addon.PDF.SetReaderOptions({ convertMode: 1, renderOptions: { resolution: 200 } });

            DWObject.LoadImageEx("", 5, () => { setCountPages( DWObject.HowManyImagesInBuffer ); }, ( errorCode, errorString ) =>  dispatch( openSnackbar({ message: `Code: ${ errorCode }, ${ errorString }`, variant: 'error' }) ) );

        }

    }

    const handleRemoveImage = () => {

        DWObject?.RemoveAllSelectedImages();

        setCountPages((prev) => prev - 1);
        setOpenConfirmacion( false );

    }

    const handleRemoveAllImages = () => {

        DWObject?.RemoveAllImages();

        setCountPages(0);
        setOpenConfirmacionAll( false );

    }

    //-------------------------------------------------------------------------------------------------

    const handleTerminar = async () => {

        setLoadingFinalizar( false );
        setProcesoTerminado( true );
        
        setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');

    }

    const handleFinalizar = async () => {

        const validate = validateFields();

        if ( !validate ) {
            return false;
        }

        setOpenDialogConfirmacionFinalizar( true );

    }

    //-------------------------------------------------------------------------------------------------

    useEffect(() => {

        if ( DWObject ) {

            const vCount = DWObject.SourceCount;
            let sourceNames = [];

            for (let i = 0; i < vCount; i++) {
                sourceNames.push( DWObject.GetSourceNameItems(i) );
            }

            setScanners( sourceNames );

        }

    }, [ DWObject ]);

    useEffect(() => {

        if ( loading ) return;
        if ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) return;

        Dynamsoft.DWT.ProductKey = process.env.REACT_APP_API_KEY_DYNAMIC_TWAIN ?? '';
        Dynamsoft.DWT.ResourcesPath = "/dwt-resources"; // ✅ relativo a /public
        Dynamsoft.DWT.Containers = [{ ContainerId: containerId, Width: width, Height: height }];

        Dynamsoft.DWT.RegisterEvent('OnWebTwainReady', () => {
            const dwt = Dynamsoft.DWT.GetWebTwain(containerId);
            setDWObject(dwt);
        });

        Dynamsoft.DWT.Load();

        return () => {
            // Limpieza al desmontar
            try {
                Dynamsoft.DWT.DeleteDWTObject(containerId);
            } catch(e) {}
        };

    }, [ loading, procesoTerminado, procesoCancelado, procesoNoEncontrado ]);

    useEffect(() => {

        async function obtener() {

            setLoading( true );

            await DetalleNotificacion(Id ?? "").then( response => {

                setTimeout(() => {

                    const { success } = response;
                    if ( success ) {

                        setNotificacion( response );

                        if ( response.idEstatus === 3 ) {
                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( response.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( response.asignadoMismoUsuario && response.idEstatus !== 54 ) {
                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( response.asignadoMismoUsuario && response.idEstatus === 54 ) {
                            setLoading( false );
                        }
                        else {
                            setProcesoNoEncontrado( true );
                        }

                        setLoading( false );

                    }
                    else {

                        setLoading( false );
                    }

                }, 700);

            });
        }

        if ( Id ) {
            obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Notificación' }, { text: 'Subir razonamiento' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                ?
                    procesoNoEncontrado
                    ?
                        <BoxProcesoNoEncontrado />
                    :
                        procesoCancelado
                        ?
                            <BoxProcesoCancelado />
                        :
                            <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ notificacion.idEstatus === 3 } />
                :
                    loading
                    ?
                        <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                            <CircularProgressIndicator />
                        </Box>
                    :
                        <>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                <Tabs value={ value } onChange={ handleChange }>

                                    <Tab label="Notificación" {...TabProps(0)} />
                                    
                                    <Tab
                                        label="Información del amparo"
                                        sx={{ display: notificacion.idAmparo !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(1)}
                                    />

                                    <Tab
                                        label="Información del expediente"
                                        sx={{ display: notificacion.idExpediente !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(2)}
                                    />

                                    <Tab
                                        label="Información del exhorto"
                                        sx={{ display: notificacion.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(3)}
                                    />

                                    <Tab
                                        label="Información del irregular"
                                        sx={{ display: notificacion.idIrregular !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(4)}
                                    />

                                </Tabs>

                            </Box>

                            <TabPanel value={ value } index={ 0 }>

                                <Box p={ 4 } component={ Paper }>

                                    <BoxHeaderInformacion
                                        numeroSeguimiento={ `GNT-${notificacion.idNotificacion}` }
                                        fecha={ new Date() }
                                        numeroBoleta={ notificacion.numeroBoleta }
                                    />

                                    <Grid container spacing={ 3 } mt={ 3 }>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="Persona a notificar"
                                                value={ notificacion.personaNotificar + ' (' + notificacion.tipoParte + ')' }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="Domicilio a notificar"
                                                value={ notificacion.domicilioNotificar }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="Tipo de notificación"
                                                value={ notificacion.tipoNotificacion }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="Forma de notificación"
                                                value={ notificacion.formaNotificacion }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 12, xs: 12 }}></Grid>

                                        <Grid size={{ md: 3, xs: 12 }}>
                                            <FormControl component="fieldset">
                                                <FormLabel component="legend">¿Se realizó la notificación?</FormLabel>
                                                <RadioGroup row>
                                                    <FormControlLabel value="Si" control={ <Radio checked={ seNotifico === true } onChange={ () => { handleChangeFechaNotificacion( true ); } } /> } label="Si" />
                                                    <FormControlLabel value="No" control={ <Radio checked={ seNotifico === false } onChange={ () => { handleChangeFechaNotificacion( false ); } } /> } label="No" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>

                                        <Grid size={{ md: 3, xs: 12 }}>

                                            {
                                                seNotifico
                                                &&
                                                    <TextField
                                                        label="Fecha de la notificación"
                                                        type="date"
                                                        fullWidth
                                                        slotProps={{
                                                            htmlInput: {
                                                                max: fechaHoy,
                                                            },
                                                            inputLabel: {
                                                                shrink: true,
                                                            }
                                                        }}
                                                        value={ fechaNotificacion }
                                                        onChange={ ( e ) => { setFechaNotificacion( e.target.value ); } }
                                                    />                                              
                                            }

                                        </Grid>

                                        <Grid size={{ md: 3, xs: 12 }}>
                                            <FormControl component="fieldset">
                                                <FormLabel component="legend">¿Desea reagendar la notificación?</FormLabel>
                                                <RadioGroup row>
                                                    <FormControlLabel value="Si" control={ <Radio checked={ reagendarNotificacion === true } onChange={ () => { handleChangeFechaReagenda( true ); } } /> } label="Si" />
                                                    <FormControlLabel value="No" control={ <Radio checked={ reagendarNotificacion === false } onChange={ () => { handleChangeFechaReagenda( false ); } } /> } label="No" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>

                                        {
                                            reagendarNotificacion
                                            &&
                                                <Grid size={{ md: 3, xs: 12 }}>

                                                    <TextField
                                                        label="Fecha para reagendar la noificación"
                                                        type="date"
                                                        fullWidth
                                                        slotProps={{
                                                            htmlInput: {
                                                                min: fechaHoy,
                                                            },
                                                            inputLabel: {
                                                                shrink: true,
                                                            }
                                                        }}
                                                        value={ fechaReagenda }
                                                        onChange={ ( e ) => { setFechaReagenda( e.target.value ); } }
                                                    />

                                                </Grid>
                                        }
                                    
                                        {
                                            !seNotifico
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <TextField
                                                        multiline
                                                        fullWidth
                                                        label="Motivo de no realizar la notificación"
                                                        value={ motivoNoNotificacion }
                                                        onChange={ ( e ) => { setMotivoNoNotificacion( e.target.value ); } }
                                                        rows={ 4 }
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            }
                                                        }}
                                                    />

                                                </Grid>
                                        }

                                    </Grid>

                                    <ToggleButtonGroup
                                        fullWidth
                                        exclusive
                                        color="primary"
                                        size="small"
                                        value={ subTab }
                                        onChange={ handleChangeSubTab }
                                        sx={{ mt: 3, mb: 2 }}
                                    >

                                        <ToggleButton value="digitalizar">Digitalizar</ToggleButton>
                                        { notificacion.documento && <ToggleButton value="documento">Cédula de notificación</ToggleButton> }
                                        <ToggleButton value="acuerdo">{ notificacion.tipoOficio ? 'Oficio a notificar' : 'Acuerdo a notificar' }</ToggleButton>

                                    </ToggleButtonGroup>

                                    {
                                        subTab === 'digitalizar'
                                        &&
                                            <Card>

                                                <CardHeader
                                                    sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                    subheader={
                                                        <Grid container spacing={ 3 }>

                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                <Typography variant='h6' sx={{ color: 'white' }}> Escanear documento(s) </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                />

                                                <CardContent sx={{ p: 3 }}>

                                                    <Grid container spacing={ 3 }>

                                                        <Grid size={{ md: 12, xs: 12 }}>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    <Grid container spacing={ 3 } sx={{}}>

                                                                        <Grid size={{ md: 12, xs: 12 }} sx={{ position: 'relative' }}>

                                                                            <div
                                                                                id={ containerId }
                                                                                style={{
                                                                                    width: '100%',
                                                                                    border: 'none',
                                                                                    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                                                                                    height: 500,
                                                                                    backgroundColor: '#f5f5f5'
                                                                                }}
                                                                            >

                                                                            </div>

                                                                            {
                                                                                countPages !== 0
                                                                                &&
                                                                                    <IconButton
                                                                                        sx={{
                                                                                            position: 'absolute',
                                                                                            bottom: 10,
                                                                                            right: 85,
                                                                                            bgcolor: '#0A192D',
                                                                                            color: 'white',
                                                                                            ':hover': {
                                                                                                bgcolor: 'rgba(0, 0, 0, 0.8)',
                                                                                            }
                                                                                        }}
                                                                                        onClick={ () => setOpenConfirmacion( true ) }
                                                                                    >
                                                                                        <MdDelete />
                                                                                    </IconButton>
                                                                            }

                                                                            {
                                                                                countPages !== 0
                                                                                &&
                                                                                    <IconButton
                                                                                        sx={{
                                                                                            position: 'absolute',
                                                                                            bottom: 10,
                                                                                            right: 30,
                                                                                            bgcolor: '#0A192D',
                                                                                            color: 'white',
                                                                                            ':hover': {
                                                                                                bgcolor: 'rgba(0, 0, 0, 0.8)',
                                                                                            }
                                                                                        }}
                                                                                        onClick={ () => setOpenConfirmacionAll( true ) }
                                                                                    >
                                                                                        <CgPlayListRemove />
                                                                                    </IconButton>
                                                                            }

                                                                        </Grid>

                                                                        <Grid size={{ md: 12, xs: 12 }}>
                                                                            <Typography variant='subtitle2' fontWeight={ 'bold' }> Número de hojas: {countPages} </Typography>
                                                                        </Grid>

                                                                    </Grid>

                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    <Grid container spacing={ 3 } >

                                                                        <Grid size={{ md: 12, xs: 12 }}>

                                                                            <FormControl fullWidth>
                                                                                <InputLabel id="select-impresoras-label">Impresora(s) disponible(s)</InputLabel>

                                                                                <Select
                                                                                    label="Impresora(s) disponible(s)"
                                                                                    labelId="select-impresoras-label"
                                                                                    value={ currentScanner }
                                                                                    onChange={ (e) => onSourceChange(e.target.value) } >

                                                                                    <MenuItem value="0" key="0"> Seleccione una impresora </MenuItem>

                                                                                    {
                                                                                        scanners.length > 0
                                                                                        &&
                                                                                        (
                                                                                            scanners.map((_name, _index) =>
                                                                                                <MenuItem value={ _name } key={ _index }> {_name} </MenuItem>
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>

                                                                        </Grid>

                                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                                            <Button
                                                                                fullWidth
                                                                                variant="contained"
                                                                                onClick={ acquireImage }
                                                                                disabled={ currentScanner === "0" || DWObject === null }
                                                                                startIcon={ <ScannerIcon /> }
                                                                            >
                                                                                Escanear
                                                                            </Button>
                                                                        </Grid>

                                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                                            <Button
                                                                                fullWidth
                                                                                variant="contained"
                                                                                color='inherit'
                                                                                startIcon={ <FileUploadIcon /> }
                                                                                onClick={ loadImagesOrPDFs }
                                                                                disabled={ DWObject === null }
                                                                            >
                                                                                Subir archivo
                                                                            </Button>
                                                                        </Grid>

                                                                    </Grid>

                                                                </Grid>

                                                            </Grid>

                                                        </Grid>

                                                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                            <Grid container spacing={ 3 } >

                                                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}> </Grid>

                                                                <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'center' }}>

                                                                    <Button
                                                                        fullWidth
                                                                        color='primary'
                                                                        variant="contained"
                                                                        onClick={ () => handleFinalizar() }
                                                                        loading={ loadingFinalizar }
                                                                    >
                                                                        Finalizar
                                                                    </Button>

                                                                </Grid>

                                                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                                            </Grid>

                                                        </Grid>

                                                        <Dialog
                                                            open={ openConfirmacion }
                                                            onClose={ () => { } }
                                                            maxWidth='xs'
                                                            fullWidth={ true }
                                                            disableEscapeKeyDown
                                                        >

                                                            <DialogTitle>
                                                                Confirmación
                                                            </DialogTitle>

                                                            <DialogContent sx={ DialogContentStyle }>

                                                                <DialogContentText>
                                                                    ¿Desea quitar la página actual?
                                                                </DialogContentText>

                                                            </DialogContent>

                                                            <DialogActions sx={ DialogActionsStyle }>
                                                                <Button color='secondary' onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                                                                <Button onClick={ handleRemoveImage } variant='contained' > Aceptar </Button>
                                                            </DialogActions>
                                                        </Dialog>

                                                        <Dialog
                                                            open={ openConfirmacionAll }
                                                            onClose={ () => { } }
                                                            maxWidth='xs'
                                                            fullWidth={ true }
                                                            disableEscapeKeyDown
                                                        >

                                                            <DialogTitle>
                                                                Confirmación
                                                            </DialogTitle>

                                                            <DialogContent sx={ DialogContentStyle }>

                                                                <DialogContentText>
                                                                    ¿Desea quitar todas la paginas?
                                                                </DialogContentText>

                                                            </DialogContent>

                                                            <DialogActions sx={ DialogActionsStyle }>
                                                                <Button color='secondary' onClick={ () => setOpenConfirmacionAll( false ) }> Cancelar </Button>
                                                                <Button onClick={ handleRemoveAllImages } variant='contained' > Aceptar </Button>
                                                            </DialogActions>
                                                        </Dialog>

                                                        <Dialog
                                                            fullWidth
                                                            maxWidth='xs'
                                                            open={ openDialogConfirmacionFinalizar }
                                                            onClose={ () => { } }
                                                        >

                                                            <DialogTitle>
                                                                Confirmación
                                                            </DialogTitle>

                                                            <DialogContent sx={ DialogContentStyle }>

                                                                <DialogContentText>
                                                                    ¿Desea finalizar la digitalización del razonamiento actuarial?
                                                                </DialogContentText>

                                                            </DialogContent>

                                                            <DialogActions sx={ DialogActionsStyle }>
                                                                <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                                                <Button loading={ loadingFinalizar } onClick={ () => GuardarDigitalizacion() } variant='contained' > Aceptar </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </Grid>

                                                </CardContent>

                                            </Card>
                                    }

                                    {
                                        subTab === 'documento'
                                        &&
                                            <Box>

                                                <iframe
                                                    title='iframe-documento'
                                                    style={{ width: '100%', height: 800, borderRadius: 8 }}
                                                    src={ notificacion.documento }
                                                />

                                            </Box>
                                    }

                                    {
                                        subTab === 'acuerdo'
                                        &&
                                            <Box>

                                                <iframe
                                                    title='iframe-acuerdo'
                                                    style={{ width: '100%', height: 800, borderRadius: 8 }}
                                                    src={ notificacion.acuerdo }
                                                />

                                            </Box>
                                    }

                                </Box>

                            </TabPanel>                            

                            <TabPanel value={ value } index={ 1 }>

                                <BoxInformacionAmparo amparo={ notificacion.amparo } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 2 }>

                                <BoxInformacionExpediente expediente={ notificacion.expediente } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 3 }>

                                <BoxInformacionExhortoRecibido exhortoRecibido={ notificacion.exhortoRecibido } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 4 }>

                                <BoxInformacionIrregular irregular={ notificacion.irregular } />

                            </TabPanel>

                        </>
            }

        </Layout>
    )
}
